<template>
  <div>
    <v-simple-table>
      <template v-slot:default v-if="items.length">
        <thead>
          <tr>
            <th>Função</th>
            <th>Indicador</th>
            <th class="text-center">Tipo Dado</th>
            <th class="text-center">Meta QTD</th>
            <th class="text-center">Meta Valor</th>
            <th class="text-center">Meta Perc</th>
            <th class="text-center">Ativo</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id_meta_individual">
            <td>{{ `${item.cod_funcao} - ${item.funcao}` }}</td>
            <td>{{ `${item.id_indicador} - ${item.indicador}` }}</td>
            <td class="text-center">{{ item.tipo_dado }}</td>
            <td class="text-center">{{ item.meta_qtde }}</td>
            <td class="text-center">
              {{ item.meta_valor | BrazilianCurrency }}
            </td>
            <td class="text-center">{{ item.meta_perc }}%</td>
            <td class="text-center">
              <v-chip
                :color="statusAtivo[item.ativo].color"
                dark
                @click="statusItem(item)"
              >
                {{ statusAtivo[item.ativo].text }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-btn
                icon
                v-can-access="573"
                @click="editItem(item)"
                color="orange"
                dark
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                icon
                v-can-access="575"
                @click="deleteItem(item)"
                class="ml-2"
                color="red"
                dark
                small
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <ModalCadMetaIndividual
      :dialog="dialog"
      :labelBtn="labelBtn"
      :editMetaInd="meta"
      @close="dialog = false"
    />
  </div>
</template>

<script>
import comissao from "@/services/http/comissaoService";
import ModalCadMetaIndividual from "./ModalCadMetaIndividual";
import currencyMixin from "@/mixins/currencyMixin";
import statusAtivo from "@/mixins/statusAtivo";
export default {
  props: {
    items: {
      type: Array
    }
  },

  components: {
    ModalCadMetaIndividual
  },

  mixins: [statusAtivo, currencyMixin],

  data() {
    return {
      dialog: false,
      labelBtn: "Salvar",
      meta: {}
    };
  },

  methods: {
    editItem(item) {
      this.meta = Object.assign({}, item);
      this.dialog = true;
      this.labelBtn = "Editar";
    },

    async deleteItem(item) {
      try {
        await this.$swal.confirm(
          "Deseja deletar o parâmetro?",
          "Essa ação não pode ser desfeita"
        );
        comissao()
          .metaIndividual(item.id_meta_individual)
          .delete(
            {},
            {
              notification: true,
              message: "Meta deletada com sucesso!"
            }
          );
      } catch (error) {
        // console.log(error);
      }
    },

    async statusItem(item) {
      await this.$swal.confirm(
        `Atualmente o status é ${item.ativo == "S" ? "ativo" : "inativo"}`,
        `Alterar o status da meta?`
      );
      this.loading = true;
      item.ativo = item.ativo == "S" ? "N" : "S";
      comissao()
        .metaIndividual(item.id_meta_individual)
        .update(item, { notification: true });
    }
  }
};
</script>

<style></style>
